import {Link} from 'react-router-dom';
import {useParams} from 'react-router-dom';
import {useState,useEffect} from 'react';
import axios from "axios";
import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
function LabMenu(){
    return (
        <section className="container mt-4">
            <div className="row nurseInpatient">
                <div className='col-md-12 col-12'>
                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="panel panel-primary">
                    <div className="panel-heading">
                    <h4 className="panel-title" >Lab Master Setting</h4>
                    </div>
                    </div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="btn-group">
                    <a href="/add-cat"><button type="button" className="btn btn"><span >Add Lab Category</span></button></a></div>
                    <div className="btn-group">
                    <a href="/add-subcat"><button type="button" className="btn btn"><span >Add Lab Sub Category </span></button></a></div>
                    <div className="btn-group">
                    <a href="/add-test"><button type="button" className="btn btn"><span >Add Lab Component </span></button></a></div>
                    <div className="btn-group">
                    <a href="/view-test"><button type="button" className="btn btn"><span >View All Category </span></button></a></div>

                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="panel panel-primary">
                    <div className="panel-heading">
                    <h4 className="panel-title" >Lab Technician</h4>
                    </div>
                    </div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="btn-group">
                    <a href="/order-accept"><button type="button" className="btn btn"><span >Order Accept</span></button></a></div>   
                    <div className="btn-group">
                    <a href="/sample-collect"><button type="button" className="btn btn"><span >Sample Collect</span></button></a></div>   
                    <div className="btn-group">
                    <a href="/sample-approve"><button type="button" className="btn btn"><span >Sample Approve</span></button></a></div>   
                    <div className="btn-group">
                    <a href="/lab-view"><button type="button" className="btn btn"><span >Lab Entry</span></button></a></div>
                    <div className="btn-group">
                    <a href="/lab-result-view"><button type="button" className="btn btn"><span >View Lab Report</span></button></a></div>
                    <div className="btn-group">
                    <a href="/lab-result-view-all"><button type="button" className="btn btn"><span >View All Lab Report</span></button></a></div>
                    <div className="btn-group">
                    <a href="/lab-machine"><button type="button" className="btn btn"><span >Lab Interface</span></button></a></div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="panel panel-primary">
                    <div className="panel-heading">
                    <h4 className="panel-title" >Lab Reports</h4>
                    </div>
                    </div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="btn-group">
                    <a href="/collection-lab"><button type="button" className="btn btn"><span >Collection Report</span></button></a></div>

                    </div>
                    </div>
               </div>
            </div>
        </section>
    )
}

export default LabMenu;